const mobNavBtn = document.querySelector(".mobile-nav-button");
const mobNavIcon = document.querySelector(".mobile-nav-button__icon");
const mobNav = document.querySelector(".mobile-nav");
const body = document.body;

function closeMobileNav() {
  mobNavIcon.classList.remove("active");
  mobNav.classList.remove("active");
  body.classList.remove("mob-menu-active");
  body.classList.remove("no-scroll");
}

mobNavBtn.addEventListener("click", function () {
  mobNavIcon.classList.toggle("active");
  mobNav.classList.toggle("active");
  body.classList.toggle("mob-menu-active");
  body.classList.toggle("no-scroll");
});

mobNav.querySelectorAll("a.mobile-nav__link, .mobile-nav__sublink").forEach(function (link) {
  link.addEventListener("click", closeMobileNav);
});

const headerSection = document.getElementById("shopify-section-header");

function updateHeaderScrolledState() {
  if (!headerSection) return;
  if (window.scrollY > 10) {
    headerSection.classList.add("header--scrolled");
  } else {
    headerSection.classList.remove("header--scrolled");
  }
}

if (headerSection) {
  updateHeaderScrolledState();
  window.addEventListener("scroll", updateHeaderScrolledState, { passive: true });
}

